import { Icon } from '../../icon/Icon';
import { GenericStatusLabel } from '../../shared/components/GenericStatusLabel/GenericStatusLabel';
import { GenericStatusColorType } from '../../shared/interfaces/generic-status';
import { UsageSummary } from './interface';
import { UsageSummaryPipelineNode } from './UsageSummaryPipelineNode';

export function UsageSummaryPipelineCell({ summary }: { summary: UsageSummary }) {
  return (
    <div className='center-flex-row text-left overflow-hidden w-100'>
      <div className='center-flex-col' style={{ width: '64px', flexShrink: 0 }}>
        <div className='text-body-3'>#{summary.pipelineSeqId}</div>
        {summary.isDeleted ? (
          <GenericStatusLabel
            className='mt-1'
            status={{
              displayName: 'Deleted',
              value: null,
              colorType: GenericStatusColorType.ERROR
            }}
          />
        ) : null}
      </div>

      <div className='border-left mx-5' style={{ height: '18px', width: '1px' }} />

      <div className='center-flex-row overflow-hidden flex-1'>
        <UsageSummaryPipelineNode
          name={summary.sourceName}
          type={summary.sourceType}
          disabled={summary.isDeleted}
        />
        <Icon
          name='pipeline-connection'
          className={`text-${summary.status.color_type} mx-4`}
          size={4}
        />
        <UsageSummaryPipelineNode
          name={summary.destinationName}
          type={summary.destinationType}
          disabled={summary.isDeleted}
        />
      </div>
    </div>
  );
}
